import { load } from './load';

const hosts = {
  load,
};

export { hosts };
